import { render, staticRenderFns } from "./MemoryInfo.vue?vue&type=template&id=24dc1a61&"
import script from "./MemoryInfo.vue?vue&type=script&lang=js&"
export * from "./MemoryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports